
$('.tab-price span').on('click',function(){
  var plan = $(this).data('plan');
  $('#js-order-plan').val(plan);
});
